export default "__VITE_ASSET__ff7c9d65__"